module.exports = __webpack_public_path__ + "static/colgadas-013-c668929f2a698bceda8796eb9dfa687d.jpg";